export const CheckboxGreenIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_4439_6717)">
    <path d="M7.5 8.33333L10 10.8333L17.5 2.5" stroke="#5BAE7E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.5 2.04825C11.7109 1.80037 10.871 1.66675 10 1.66675C5.39765 1.66675 1.66669 5.39771 1.66669 10.0001C1.66669 14.6024 5.39765 18.3334 10 18.3334C14.6024 18.3334 18.3334 14.6024 18.3334 10.0001C18.3334 9.12908 18.1997 8.28928 17.9519 7.50008" stroke="#5BAE7E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_4439_6717">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>

